/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * What to do with matching requests.
 */
export const Action = {
  ActionDeny: "ACTION_DENY",
} as const;
/**
 * What to do with matching requests.
 */
export type Action = ClosedEnum<typeof Action>;

/**
 * Blocks matching requests.
 */
export type FirewallPolicy = {
  /**
   * What to do with matching requests.
   */
  action: Action;
};

/** @internal */
export const Action$inboundSchema: z.ZodNativeEnum<typeof Action> = z
  .nativeEnum(Action);
/** @internal */
export const Action$outboundSchema: z.ZodNativeEnum<typeof Action> =
  Action$inboundSchema;

/** @internal */
export const FirewallPolicy$inboundSchema: z.ZodType<
  FirewallPolicy,
  z.ZodTypeDef,
  unknown
> = z.object({
  action: Action$inboundSchema,
});
/** @internal */
export type FirewallPolicy$Outbound = {
  action: string;
};

/** @internal */
export const FirewallPolicy$outboundSchema: z.ZodType<
  FirewallPolicy$Outbound,
  z.ZodTypeDef,
  FirewallPolicy
> = z.object({
  action: Action$outboundSchema,
});

export function firewallPolicyToJSON(firewallPolicy: FirewallPolicy): string {
  return JSON.stringify(FirewallPolicy$outboundSchema.parse(firewallPolicy));
}
export function firewallPolicyFromJSON(
  jsonString: string,
): SafeParseResult<FirewallPolicy, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => FirewallPolicy$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'FirewallPolicy' from JSON`,
  );
}
